import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

const UnlimitedHostingOrder = ({
  currentProduct,
  hostingProduct,
  setHostingProduct,
}) => {
  const { name } = currentProduct.current;
  const productGroup = useSelector((state) => state.hosting.products);

  const [productFamily, setProductFamily] = useState(null);

  useEffect(() => {
    const getProductsFamily = productGroup.filter((prods) =>
      prods.name.includes(name)
    );
    setProductFamily(getProductsFamily);
  }, [productGroup, name]);

  const selectBackupHandler = (e) => {
    const unliPid = +e.target.value;
    setHostingProduct({
      type: "SET_CURRENT_PID",
      payload: unliPid,
    });
  };

  const OptionBackup = () => {
    if (productFamily) {
      return (
        <div className="row">
          {productFamily.map((opt, i) => (
            <div className="col-12 col-md-6 col-lg-3" key={opt.pid}>
              <div className="form-check mt-3">
                <input
                  type="radio"
                  name="optionBak"
                  id={`${opt.pid}optionBak`}
                  className="form-check-input"
                  value={opt.pid}
                  checked={hostingProduct.pid === opt.pid}
                  onChange={selectBackupHandler}
                />
                <label
                  htmlFor={`${opt.pid}optionBak`}
                  className="ms-3 form-check-label"
                >
                  {i === 0 && "No Backup"}
                  {i === 1 && "10GB Backup"}
                  {i === 2 && "20GB Backup"}
                  {i === 3 && "50GB Backup"}
                  {i === 4 && "100GB Backup"}
                </label>
              </div>
            </div>
          ))}
        </div>
      );
    }
  };

  return (
    <div className="row">
      <div className="col-12">
        <label htmlFor="cloudPop" className="form-label fw-bold mb-0">
          Opsi Backup:
        </label>
        <OptionBackup />
      </div>
    </div>
  );
};

export default UnlimitedHostingOrder;
